import { ApiClient } from '../../core/api/ApiClient';
import { RankingRepositoryImpl } from './implementations';
import { RankingService } from './services';

export * from './implementations';
export * from './interfaces';
export * from './services';

class RankingDomainContainer {
  constructor() {
    this._apiClient = null;
    this._rankingRepository = null;
    this._rankingService = null;
  }

  get apiClient() {
    if (!this._apiClient) {
      const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';
      this._apiClient = new ApiClient(baseURL);
    }
    return this._apiClient;
  }

  get rankingRepository() {
    if (!this._rankingRepository) {
      this._rankingRepository = new RankingRepositoryImpl(this.apiClient);
    }
    return this._rankingRepository;
  }

  get rankingService() {
    if (!this._rankingService) {
      this._rankingService = new RankingService(this.rankingRepository);
    }
    return this._rankingService;
  }

  reset() {
    this._apiClient = null;
    this._rankingRepository = null;
    this._rankingService = null;
  }
}

const container = new RankingDomainContainer();

export const getRankingService = () => container.rankingService;
export const resetRankingContainer = () => container.reset();
